import React, { FC } from 'react';
import styles from './Loader.module.css';

export const Loader: FC = () => {
    return (
        <div
            className={
                // other classes
                ` ${styles.loader}`
            }></div>
    );
};
